export const countries = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
  { value: 'UK', label: 'United Kindgom' },
  { value: 'FR', label: 'France' },
  { value: 'DE', label: 'Germany' },
  { value: 'ES', label: 'Spain' },
  { value: 'IT', label: 'Italy' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'BE', label: 'Belgium' },
  { value: 'AT', label: 'Austria' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'FI', label: 'Finland' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IL', label: 'Israel' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'NO', label: 'Norway' },
  { value: 'PT', label: 'Portugal' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'TR', label: 'Turkey' },
];

export const states = {
  US: [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' },
    { value: 'DC', label: 'District of Columbia' },
    { value: 'AS', label: 'American Samoa' },
    { value: 'GU', label: 'Guam' },
    { value: 'MP', label: 'Northern Mariana Islands' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'UM', label: 'United States Minor Outlying Islands' },
    { value: 'VI', label: 'Virgin Islands, U.S.' },
  ],

  CA: [
    { value: 'AB', label: 'Alberta' },
    { value: 'BC', label: 'British Columbia' },
    { value: 'MB', label: 'Manitoba' },
    { value: 'NB', label: 'New Brunswick' },
    { value: 'NL', label: 'Newfoundland and Labrador' },
    { value: 'NS', label: 'Nova Scotia' },
    { value: 'ON', label: 'Ontario' },
    { value: 'PE', label: 'Prince Edward Island' },
    { value: 'QC', label: 'Quebec' },
    { value: 'SK', label: 'Saskatchewan' },
    { value: 'NT', label: 'Northwest Territories' },
    { value: 'NU', label: 'Nunavut' },
    { value: 'YT', label: 'Yukon' },
  ],

  UK: [
    { value: 'BKM', label: 'Buckinghamshire' },
    { value: 'CAM', label: 'Cambridgeshire' },
    { value: 'CMA', label: 'Cumbria' },
    { value: 'DBY', label: 'Derbyshire' },
    { value: 'DEV', label: 'Devon' },
    { value: 'DOR', label: 'Dorset' },
    { value: 'ESX', label: 'East Sussex' },
    { value: 'ESS', label: 'Essex' },
    { value: 'GLS', label: 'Gloucestershire' },
    { value: 'HAM', label: 'Hampshire' },
    { value: 'HRT', label: 'Hertfordshire' },
    { value: 'KEN', label: 'Kent' },
    { value: 'LAN', label: 'Lancashire' },
    { value: 'LEC', label: 'Leicestershire' },
    { value: 'LIN', label: 'Lincolnshire' },
    { value: 'NFK', label: 'Norfolk' },
    { value: 'NYK', label: 'North Yorkshire' },
    { value: 'NTH', label: 'Northamptonshire' },
    { value: 'NTT', label: 'Nottinghamshire' },
    { value: 'OXF', label: 'Oxfordshire' },
    { value: 'SOM', label: 'Somerset' },
    { value: 'STS', label: 'Staffordshire' },
    { value: 'SFK', label: 'Suffolk' },
    { value: 'SRY', label: 'Surrey' },
    { value: 'WAR', label: 'Warwickshire' },
    { value: 'WSX', label: 'West Sussex' },
    { value: 'WOR', label: 'Worcestershire' },
    { value: 'LND', label: 'London, City of' },
    { value: 'BDG', label: 'Barking and Dagenham' },
    { value: 'BNE', label: 'Barnet' },
    { value: 'BEX', label: 'Bexley' },
    { value: 'BEN', label: 'Brent' },
    { value: 'BRY', label: 'Bromley' },
    { value: 'CMD', label: 'Camden' },
    { value: 'CRY', label: 'Croydon' },
    { value: 'EAL', label: 'Ealing' },
    { value: 'ENF', label: 'Enfield' },
    { value: 'GRE', label: 'Greenwich' },
    { value: 'HCK', label: 'Hackney' },
    { value: 'HMF', label: 'Hammersmith and Fulham' },
    { value: 'HRY', label: 'Haringey' },
    { value: 'HRW', label: 'Harrow' },
    { value: 'HAV', label: 'Havering' },
    { value: 'HIL', label: 'Hillingdon' },
    { value: 'HNS', label: 'Hounslow' },
    { value: 'ISL', label: 'Islington' },
    { value: 'KEC', label: 'Kensington and Chelsea' },
    { value: 'KTT', label: 'Kingston upon Thames' },
    { value: 'LBH', label: 'Lambeth' },
    { value: 'LEW', label: 'Lewisham' },
    { value: 'MRT', label: 'Merton' },
    { value: 'NWM', label: 'Newham' },
    { value: 'RDB', label: 'Redbridge' },
    { value: 'RIC', label: 'Richmond upon Thames' },
    { value: 'SWK', label: 'Southwark' },
    { value: 'STN', label: 'Sutton' },
    { value: 'TWH', label: 'Tower Hamlets' },
    { value: 'WFT', label: 'Waltham Forest' },
    { value: 'WND', label: 'Wandsworth' },
    { value: 'WSM', label: 'Westminster' },
    { value: 'BNS', label: 'Barnsley' },
    { value: 'BIR', label: 'Birmingham' },
    { value: 'BOL', label: 'Bolton' },
    { value: 'BRD', label: 'Bradford' },
    { value: 'BUR', label: 'Bury' },
    { value: 'CLD', label: 'Calderdale' },
    { value: 'COV', label: 'Coventry' },
    { value: 'DNC', label: 'Doncaster' },
    { value: 'DUD', label: 'Dudley' },
    { value: 'GAT', label: 'Gateshead' },
    { value: 'KIR', label: 'Kirklees' },
    { value: 'KWL', label: 'Knowsley' },
    { value: 'LDS', label: 'Leeds' },
    { value: 'LIV', label: 'Liverpool' },
    { value: 'MAN', label: 'Manchester' },
    { value: 'NET', label: 'Newcastle upon Tyne' },
    { value: 'NTY', label: 'North Tyneside' },
    { value: 'OLD', label: 'Oldham' },
    { value: 'RCH', label: 'Rochdale' },
    { value: 'ROT', label: 'Rotherham' },
    { value: 'SHN', label: 'St. Helens' },
    { value: 'SLF', label: 'Salford' },
    { value: 'SAW', label: 'Sandwell' },
    { value: 'SFT', label: 'Sefton' },
    { value: 'SHF', label: 'Sheffield' },
    { value: 'SOL', label: 'Solihull' },
    { value: 'STY', label: 'South Tyneside' },
    { value: 'SKP', label: 'Stockport' },
    { value: 'SND', label: 'Sunderland' },
    { value: 'TAM', label: 'Tameside' },
    { value: 'TRF', label: 'Trafford' },
    { value: 'WKF', label: 'Wakefield' },
    { value: 'WLL', label: 'Walsall' },
    { value: 'WGN', label: 'Wigan' },
    { value: 'WRL', label: 'Wirral' },
    { value: 'WLV', label: 'Wolverhampton' },
    { value: 'BAS', label: 'Bath and North East Somerset' },
    { value: 'BDF', label: 'Bedford' },
    { value: 'BBD', label: 'Blackburn with Darwen' },
    { value: 'BPL', label: 'Blackpool' },
    { value: 'BMH', label: 'Bournemouth' },
    { value: 'BRC', label: 'Bracknell Forest' },
    { value: 'BNH', label: 'Brighton and Hove' },
    { value: 'BST', label: 'Bristol, City of' },
    { value: 'CBF', label: 'Central Bedfordshire' },
    { value: 'CHE', label: 'Cheshire East' },
    { value: 'CHW', label: 'Cheshire West and Chester' },
    { value: 'CON', label: 'Cornwall' },
    { value: 'DAL', label: 'Darlington' },
    { value: 'DER', label: 'Derby' },
    { value: 'DUR', label: 'Durham County' },
    { value: 'ERY', label: 'East Riding of Yorkshire' },
    { value: 'HAL', label: 'Halton' },
    { value: 'HPL', label: 'Hartlepool' },
    { value: 'HEF', label: 'Herefordshire' },
    { value: 'IOW', label: 'Isle of Wight' },
    { value: 'IOS', label: 'Isles of Scilly' },
    { value: 'KHL', label: 'Kingston upon Hull' },
    { value: 'LCE', label: 'Leicester' },
    { value: 'LUT', label: 'Luton' },
    { value: 'MDW', label: 'Medway' },
    { value: 'MDB', label: 'Middlesbrough' },
    { value: 'MIK', label: 'Milton Keynes' },
    { value: 'NEL', label: 'North East Lincolnshire' },
    { value: 'NLN', label: 'North Lincolnshire' },
    { value: 'NSM', label: 'North Somerset' },
    { value: 'NBL', label: 'Northumberland' },
    { value: 'NGM', label: 'Nottingham' },
    { value: 'PTE', label: 'Peterborough' },
    { value: 'PLY', label: 'Plymouth' },
    { value: 'POL', label: 'Poole' },
    { value: 'POR', label: 'Portsmouth' },
    { value: 'RDG', label: 'Reading' },
    { value: 'RCC', label: 'Redcar and Cleveland' },
    { value: 'RUT', label: 'Rutland' },
    { value: 'SHR', label: 'Shropshire' },
    { value: 'SLG', label: 'Slough' },
    { value: 'SGC', label: 'South Gloucestershire' },
    { value: 'STH', label: 'Southampton' },
    { value: 'SOS', label: 'Southend-on-Sea' },
    { value: 'STT', label: 'Stockton-on-Tees' },
    { value: 'STE', label: 'Stoke-on-Trent' },
    { value: 'SWD', label: 'Swindon' },
    { value: 'TFW', label: 'Telford and Wrekin' },
    { value: 'THR', label: 'Thurrock' },
    { value: 'TOB', label: 'Torbay' },
    { value: 'WRT', label: 'Warrington' },
    { value: 'WBK', label: 'West Berkshire' },
    { value: 'WIL', label: 'Wiltshire' },
    { value: 'WNM', label: 'Windsor and Maidenhead' },
    { value: 'WOK', label: 'Wokingham' },
    { value: 'YOR', label: 'York' },
    { value: 'ANN', label: 'Antrim and Newtownabbey' },
    { value: 'AND', label: 'Ards and North Down' },
    { value: 'ABC', label: 'Armagh, Banbridge and Craigavon' },
    { value: 'BFS', label: 'Belfast' },
    { value: 'CCG', label: 'Causeway Coast and Glens' },
    { value: 'DRS', label: 'Derry and Strabane' },
    { value: 'FMO', label: 'Fermanagh and Omagh' },
    { value: 'LBC', label: 'Lisburn and Castlereagh' },
    { value: 'MEA', label: 'Mid and East Antrim' },
    { value: 'MUL', label: 'Mid Ulster' },
    { value: 'NMD', label: 'Newry, Mourne and Down' },
    { value: 'ABE', label: 'Aberdeen City' },
    { value: 'ABD', label: 'Aberdeenshire' },
    { value: 'ANS', label: 'Angus' },
    { value: 'AGB', label: 'Argyll and Bute' },
    { value: 'CLK', label: 'Clackmannanshire' },
    { value: 'DGY', label: 'Dumfries and Galloway' },
    { value: 'DND', label: 'Dundee City' },
    { value: 'EAY', label: 'East Ayrshire' },
    { value: 'EDU', label: 'East Dunbartonshire' },
    { value: 'ELN', label: 'East Lothian' },
    { value: 'ERW', label: 'East Renfrewshire' },
    { value: 'EDH', label: 'Edinburgh, City of' },
    { value: 'ELS', label: 'Eilean Siar' },
    { value: 'FAL', label: 'Falkirk' },
    { value: 'FIF', label: 'Fife' },
    { value: 'GLG', label: 'Glasgow City' },
    { value: 'HLD', label: 'Highland' },
    { value: 'IVC', label: 'Inverclyde' },
    { value: 'MLN', label: 'Midlothian' },
    { value: 'MRY', label: 'Moray' },
    { value: 'NAY', label: 'North Ayrshire' },
    { value: 'NLK', label: 'North Lanarkshire' },
    { value: 'ORK', label: 'Orkney Islands' },
    { value: 'PKN', label: 'Perth and Kinross' },
    { value: 'RFW', label: 'Renfrewshire' },
    { value: 'SCB', label: 'Scottish Borders, The' },
    { value: 'ZET', label: 'Shetland Islands' },
    { value: 'SAY', label: 'South Ayrshire' },
    { value: 'SLK', label: 'South Lanarkshire' },
    { value: 'STG', label: 'Stirling' },
    { value: 'WDU', label: 'West Dunbartonshire' },
    { value: 'WLN', label: 'West Lothian' },
    { value: 'BGW', label: 'Blaenau Gwent' },
    { value: 'BGE', label: 'Bridgend [Pen-y-bont ar Ogwr GB-POG]' },
    { value: 'CAY', label: 'Caerphilly [Caerffili GB-CAF]' },
    { value: 'CRF', label: 'Cardiff [Caerdydd GB-CRD]' },
    { value: 'CMN', label: 'Carmarthenshire [Sir Gaerfyrddin GB-GFY]' },
    { value: 'CGN', label: 'Ceredigion [Sir Ceredigion]' },
    { value: 'CWY', label: 'Conwy' },
    { value: 'DEN', label: 'Denbighshire [Sir Ddinbych GB-DDB]' },
    { value: 'FLN', label: 'Flintshire [Sir y Fflint GB-FFL]' },
    { value: 'GWN', label: 'Gwynedd' },
    { value: 'AGY', label: 'Isle of Anglesey [Sir Ynys Môn GB-YNM]' },
    { value: 'MTY', label: 'Merthyr Tydfil [Merthyr Tudful GB-MTU]' },
    { value: 'MON', label: 'Monmouthshire [Sir Fynwy GB-FYN]' },
    { value: 'NTL', label: 'Neath Port Talbot [Castell-nedd Port Talbot GB-CTL]' },
    { value: 'NWP', label: 'Newport [Casnewydd GB-CNW]' },
    { value: 'PEM', label: 'Pembrokeshire [Sir Benfro GB-BNF]' },
    { value: 'POW', label: 'Powys' },
    { value: 'RCT', label: 'Rhondda, Cynon, Taff [Rhondda, Cynon, Taf]' },
    { value: 'SWA', label: 'Swansea [Abertawe GB-ATA]' },
    { value: 'TOF', label: 'Torfaen [Tor-faen]' },
    { value: 'VGL', label: 'Vale of Glamorgan, The [Bro Morgannwg GB-BMG]' },
    { value: 'WRX', label: 'Wrexham [Wrecsam GB-WRC]' },
  ],

  FR: [
    { value: 'ARA', label: 'Auvergne-Rhône-Alpes' },
    { value: 'BFC', label: 'Bourgogne-Franche-Comté' },
    { value: 'BRE', label: 'Bretagne' },
    { value: 'CVL', label: 'Centre-Val de Loire ' },
    { value: 'COR', label: 'Corse collectivity' },
    { value: 'GES', label: 'Grand-Est' },
    { value: 'GUA', label: 'Guadeloupe' },
    { value: 'HDF', label: 'Hauts-de-France' },
    { value: 'IDF', label: 'Île-de-France' },
    { value: 'MAY', label: 'Mayotte' },
    { value: 'NOR', label: 'Normandie' },
    { value: 'NAQ', label: 'Nouvelle-Aquitaine' },
    { value: 'OCC', label: 'Occitanie' },
    { value: 'PDL', label: 'Pays-de-la-Loire' },
    { value: 'PAC', label: 'Provence-Alpes-Côte-d’Azur' },
    { value: 'LRE', label: 'La Réunion' },
  ],

  DE: [
    { value: 'BW', label: 'Baden-Württemberg' },
    { value: 'BY', label: 'Bayern (Bavaria)' },
    { value: 'BE', label: 'Berlin' },
    { value: 'BB', label: 'Brandenburg' },
    { value: 'HB', label: 'Bremen' },
    { value: 'HH', label: 'Hamburg' },
    { value: 'HE', label: 'Hessen' },
    { value: 'MV', label: 'Mecklenburg-Western Pomerania' },
    { value: 'NI', label: 'Niedersachsen (Lower Saxony)' },
    { value: 'NW', label: 'Nordrhein-Westfalen (North Rhine-Westphalia)' },
    { value: 'RP', label: 'Rheinland-Pfalz (Rhineland-Palatinate)' },
    { value: 'SL', label: 'Saarland' },
    { value: 'SN', label: 'Sachsen (Saxony)' },
    { value: 'ST', label: 'Sachsen-Anhalt (Saxony-Anhalt)' },
    { value: 'SH', label: 'Schleswig-Holstein' },
    { value: 'TH', label: 'Thüringen (Thuringia)' },
  ],

  ES: [
    { value: 'AN', label: 'Andalucía (Andalusia)' },
    { value: 'AR', label: 'Aragón (Aragon)' },
    { value: 'AS', label: 'Asturias, Principado de (Principality of Asturias)' },
    { value: 'CN', label: 'Canarias (Canary Islands)' },
    { value: 'CB', label: 'Cantabria' },
    { value: 'CL', label: 'Castilla y León' },
    { value: 'CM', label: 'Castilla-La Mancha' },
    { value: 'CT', label: 'Catalunya (Catalonia)' },
    { value: 'CE', label: 'Ceuta' },
    { value: 'EX', label: 'Extremadura' },
    { value: 'GA', label: 'Galicia' },
    { value: 'IB', label: 'Illes Balears (Balearic Islands)' },
    { value: 'RI', label: 'La Rioja' },
    { value: 'MD', label: 'Madrid, Comunidad de' },
    { value: 'ML', label: 'Melilla' },
    { value: 'MC', label: 'Murcia, Región de' },
    { value: 'NC', label: 'Navarra, Comunidad Foral de (Chartered Community of Navarre)' },
    { value: 'PV', label: 'País Vasco (Basque Country)' },
    { value: 'VC', label: 'Valenciana, Comunidad (Valencian Community)' },
  ],

  IT: [
    { value: '65', label: 'Abruzzo' },
    { value: '77', label: 'Basilicata' },
    { value: '78', label: 'Calabria' },
    { value: '72', label: 'Campania' },
    { value: '45', label: 'Emilia-Romagna' },
    { value: '36', label: 'Friuli-Venezia Giulia' },
    { value: '62', label: 'Lazio' },
    { value: '42', label: 'Liguria' },
    { value: '25', label: 'Lombardia (Lombardy)' },
    { value: '57', label: 'Marche' },
    { value: '67', label: 'Molise' },
    { value: '21', label: 'Piemonte' },
    { value: '75', label: 'Puglia (Apulia)' },
    { value: '88', label: 'Sardegna (Sardinia)' },
    { value: '82', label: 'Sicilia (Sicily)' },
    { value: '52', label: 'Toscana (Tuscany)' },
    { value: '32', label: 'Trentino-Alto Adige (Trentino-South Tyrol)' },
    { value: '55', label: 'Umbria' },
    { value: '23', label: "Valle d'Aosta (Aosta Valley)" },
    { value: '34', label: 'Veneto' },
  ],

  NL: [
    { value: 'DR', label: 'Drenthe' },
    { value: 'FL', label: 'Flevoland' },
    { value: 'FR', label: 'Frieslan' },
    { value: 'GE', label: 'Gelderland' },
    { value: 'GR', label: 'Groningen' },
    { value: 'LI', label: 'Limburg' },
    { value: 'NB', label: 'North Brabant' },
    { value: 'NH', label: 'North Holland' },
    { value: 'OV', label: 'Overijssel' },
    { value: 'UT', label: 'Utrecht' },
    { value: 'ZE', label: 'Zeeland' },
    { value: 'ZH', label: 'South Holland' },
    { value: 'AW', label: 'Aruba' },
    { value: 'CW', label: 'Curacao' },
    { value: 'SX', label: 'Sint Maarten' },
    { value: 'BQ1', label: 'Bonaire' },
    { value: 'BQ2', label: 'Saba' },
    { value: 'BQ3', label: 'Sint Eustatius' },
  ],

  BE: [
    { value: 'BRU', label: 'Brussels-Capital Region' },
    { value: 'VLG', label: 'Flemish Region' },
    { value: 'WAL', label: 'Walloon Region' },

    { value: 'VAN', label: 'Antwerpen' },
    { value: 'WBR', label: 'Brabant wallon' },
    { value: 'WHT', label: 'Hainaut' },
    { value: 'WLG', label: 'Liège' },
    { value: 'VLI', label: 'Limburg' },
    { value: 'WLX', label: 'Luxembourg' },
    { value: 'WNA', label: 'Namur' },
    { value: 'VOV', label: 'Oost-Vlaanderen' },
    { value: 'VBR', label: 'Vlaams-Brabant' },
    { value: 'VWV', label: 'West-Vlaanderen' },
  ],

  CH: [
    { value: 'AG', label: 'Aargau' },
    { value: 'AR', label: 'Appenzell Ausserrhoden' },
    { value: 'AI', label: 'Appenzell Innerrhoden' },
    { value: 'BL', label: 'Basel-Landschaft' },
    { value: 'BS', label: 'Basel-Stadt' },
    { value: 'BE', label: 'Bern/Berne' },
    { value: 'FR', label: 'Fribourg/Freiburg' },
    { value: 'GE', label: 'Genève' },
    { value: 'GL', label: 'Glarus' },
    { value: 'GR', label: 'Graubünden/Grigioni/Grischun/Grisons' },
    { value: 'JU', label: 'Jura' },
    { value: 'LU', label: 'Luzern' },
    { value: 'NE', label: 'Neuchâtel' },
    { value: 'NW', label: 'Nidwalden' },
    { value: 'OW', label: 'Obwalden' },
    { value: 'SG', label: 'Sankt Gallen' },
    { value: 'SH', label: 'Schaffhausen' },
    { value: 'SZ', label: 'Schwyz' },
    { value: 'SO', label: 'Solothurn' },
    { value: 'TG', label: 'Thurgau' },
    { value: 'TI', label: 'Ticino' },
    { value: 'UR', label: 'Uri' },
    { value: 'VS', label: 'Valais/Wallis' },
    { value: 'VD', label: 'Vaud' },
    { value: 'ZG', label: 'Zug' },
    { value: 'ZH', label: 'Zürich' },
  ],

  AT: [
    { value: '01', label: 'Burgenland' },
    { value: '02', label: 'Carinthia' },
    { value: '03', label: 'Lower Austria' },
    { value: '04', label: 'Upper Austria' },
    { value: '05', label: 'Salzburg' },
    { value: '06', label: 'Styria' },
    { value: '07', label: 'Tyrol' },
    { value: '08', label: 'Vorarlberg' },
    { value: '09', label: 'Vienna' },
  ],

  BG: [
    { value: '01', label: 'Blagoevgrad' },
    { value: '02', label: 'Burgas' },
    { value: '08', label: 'Dobrich' },
    { value: '07', label: 'Gabrovo' },
    { value: '26', label: 'Haskovo' },
    { value: '09', label: 'Kardzhali' },
    { value: '10', label: 'Kyustendil' },
    { value: '11', label: 'Lovech' },
    { value: '12', label: 'Montana' },
    { value: '13', label: 'Pazardzhik' },
    { value: '14', label: 'Pernik' },
    { value: '15', label: 'Pleven' },
    { value: '16', label: 'Plovdiv' },
    { value: '17', label: 'Razgrad' },
    { value: '18', label: 'Ruse' },
    { value: '27', label: 'Shumen' },
    { value: '19', label: 'Silistra' },
    { value: '20', label: 'Sliven' },
    { value: '21', label: 'Smolyan' },
    { value: '23', label: 'Sofia' },
    { value: '22', label: 'Sofia (stolitsa)' },
    { value: '24', label: 'Stara Zagora' },
    { value: '25', label: 'Targovishte' },
    { value: '03', label: 'Varna' },
    { value: '04', label: 'Veliko Tarnovo' },
    { value: '05', label: 'Vidin' },
    { value: '06', label: 'Vratsa' },
    { value: '28', label: 'Yambol' },
  ],

  CZ: [
    { value: '31', label: 'South Bohemia' },
    { value: '64', label: 'South Moravia' },
    { value: '41', label: 'Karlovy Vary' },
    { value: '52', label: 'Hradec Králové' },
    { value: '51', label: 'Liberec' },
    { value: '80', label: 'Moravia-Silesia' },
    { value: '71', label: 'Olomouc' },
    { value: '53', label: 'Pardubice' },
    { value: '32', label: 'Plzeň' },
    { value: '10', label: 'Prague' },
    { value: '20', label: 'Central Bohemia' },
    { value: '42', label: 'Ústí nad Labem' },
    { value: '63', label: 'Vysočina' },
    { value: '72', label: 'Zlín' },
  ],

  DK: [
    { value: '84', label: 'Hovedstaden' },
    { value: '82', label: 'Midtjylland' },
    { value: '81', label: 'Nordjylland' },
    { value: '85', label: 'Sjælland' },
    { value: '83', label: 'Syddanmark' },
  ],

  FI: [
    { value: '01', label: 'Åland' },
    { value: '02', label: 'South Karelia' },
    { value: '03', label: 'Southern Ostrobothnia' },
    { value: '04', label: 'Southern Savonia' },
    { value: '05', label: 'Kainuu' },
    { value: '06', label: 'Tavastia Proper' },
    { value: '07', label: 'Central Ostrobothnia' },
    { value: '08', label: 'Central Finland' },
    { value: '09', label: 'Kymenlaakso' },
    { value: '10', label: 'Lapland' },
    { value: '11', label: 'Pirkanmaa' },
    { value: '12', label: 'Ostrobothnia' },
    { value: '13', label: 'North Karelia' },
    { value: '14', label: 'Northern Ostrobothnia' },
    { value: '15', label: 'Northern Savonia' },
    { value: '16', label: 'Päijänne Tavastia' },
    { value: '17', label: 'Satakunta' },
    { value: '18', label: 'Uusimaa' },
    { value: '19', label: 'Southwest Finland' },
  ],

  GI: [{ value: 'GI', label: 'Gibraltar' }],

  GR: [
    { value: 'A', label: 'Eastern Macedonia and Thrace' },
    { value: 'I', label: 'Attica' },
    { value: 'G', label: 'Western Greece' },
    { value: 'C', label: 'Western Macedonia' },
    { value: 'F', label: 'Ionian Islands' },
    { value: 'D', label: 'Epirus' },
    { value: 'B', label: 'Central Macedonia' },
    { value: 'M', label: 'Crete' },
    { value: 'L', label: 'Southern Aegean' },
    { value: 'J', label: 'Peloponnese' },
    { value: 'H', label: 'Central Greece' },
    { value: 'E', label: 'Thessaly' },
    { value: 'K', label: 'Northern Aegean' },
    { value: '69', label: 'Ágion Óros' },
  ],

  IE: [
    { value: 'C', label: 'Connaught' },
    { value: 'L', label: 'Leinster' },
    { value: 'M', label: 'Munster' },
    { value: 'U', label: 'Ulster' },
    { value: 'CW', label: 'Carlow' },
    { value: 'CN', label: 'Cavan' },
    { value: 'CE', label: 'Clare' },
    { value: 'CO', label: 'Cork' },
    { value: 'DL', label: 'Donegal' },
    { value: 'D', label: 'Dublin' },
    { value: 'G', label: 'Galway' },
    { value: 'KY', label: 'Kerry' },
    { value: 'KE', label: 'Kildare' },
    { value: 'KK', label: 'Kilkenny' },
    { value: 'LS', label: 'Laois' },
    { value: 'LM', label: 'Leitrim' },
    { value: 'LK', label: 'Limerick' },
    { value: 'LD', label: 'Longford' },
    { value: 'LH', label: 'Louth' },
    { value: 'MO', label: 'Mayo' },
    { value: 'MH', label: 'Meath' },
    { value: 'MN', label: 'Monaghan' },
    { value: 'OY', label: 'Offaly' },
    { value: 'RN', label: 'Roscommon' },
    { value: 'SO', label: 'Sligo' },
    { value: 'TA', label: 'Tipperary' },
    { value: 'WD', label: 'Waterford' },
    { value: 'WH', label: 'Westmeath' },
    { value: 'WX', label: 'Wexford' },
    { value: 'WW', label: 'Wicklow' },
  ],

  IS: [
    { value: '1', label: 'Höfuðborgarsvæðið' },
    { value: '2', label: 'Suðurnes' },
    { value: '3', label: 'Vesturland' },
    { value: '4', label: 'Vestfirðir' },
    { value: '5', label: 'Norðurland vestra' },
    { value: '6', label: 'Norðurland eystra' },
    { value: '7', label: 'Austurland' },
    { value: '8', label: 'Suðurland' },
  ],

  IL: [
    { value: 'D', label: 'HaDarom' },
    { value: 'M', label: 'HaMerkaz' },
    { value: 'Z', label: 'HaTsafon' },
    { value: 'HA', label: 'Haifa' },
    { value: 'TA', label: 'Tel Aviv' },
    { value: 'JM', label: 'Jerusalem' },
  ],

  LI: [
    { value: '01', label: 'Balzers' },
    { value: '02', label: 'Eschen' },
    { value: '03', label: 'Gamprin' },
    { value: '04', label: 'Mauren' },
    { value: '05', label: 'Planken' },
    { value: '06', label: 'Ruggell' },
    { value: '07', label: 'Schaan' },
    { value: '08', label: 'Schellenberg' },
    { value: '09', label: 'Triesen' },
    { value: '10', label: 'Triesenberg' },
    { value: '11', label: 'Vaduz' },
  ],

  LU: [
    { value: 'CA', label: 'Capellen' },
    { value: 'CL', label: 'Clervaux' },
    { value: 'DI', label: 'Diekirch' },
    { value: 'EC', label: 'Echternach' },
    { value: 'ES', label: 'Esch-sur-Alzette' },
    { value: 'GR', label: 'Grevenmacher' },
    { value: 'LU', label: 'Luxembourg' },
    { value: 'ME', label: 'Mersch' },
    { value: 'RD', label: 'Redange' },
    { value: 'RM', label: 'Remich' },
    { value: 'VD', label: 'Vianden' },
    { value: 'WI', label: 'Wiltz' },
  ],

  MQ: [{ value: 'MQ', label: 'Martinique' }],

  NO: [
    { value: '02', label: 'Akershus' },
    { value: '09', label: 'Aust-Agder' },
    { value: '06', label: 'Buskerud' },
    { value: '20', label: 'Finnmark/Finnmárku' },
    { value: '04', label: 'Hedmark' },
    { value: '12', label: 'Hordaland' },
    { value: '15', label: 'Møre og Romsdal' },
    { value: '18', label: 'Nordland' },
    { value: '05', label: 'Oppland' },
    { value: '03', label: 'Oslo' },
    { value: '11', label: 'Rogaland' },
    { value: '14', label: 'Sogn og Fjordane' },
    { value: '08', label: 'Telemark' },
    { value: '19', label: 'Troms/Romsa' },
    { value: '50', label: 'Trøndelag' },
    { value: '10', label: 'Vest-Agder' },
    { value: '07', label: 'Vestfold' },
    { value: '01', label: 'Østfold' },
    { value: '22', label: 'Jan Mayen' },
    { value: '21', label: 'Svalbard' },
  ],

  PT: [
    { value: '01', label: 'Aveiro' },
    { value: '02', label: 'Beja' },
    { value: '03', label: 'Braga' },
    { value: '04', label: 'Bragança' },
    { value: '05', label: 'Castelo Branco' },
    { value: '06', label: 'Coimbra' },
    { value: '07', label: 'Évora' },
    { value: '08', label: 'Faro' },
    { value: '09', label: 'Guarda' },
    { value: '10', label: 'Leiria' },
    { value: '11', label: 'Lisboa' },
    { value: '12', label: 'Portalegre' },
    { value: '13', label: 'Porto' },
    { value: '14', label: 'Santarém' },
    { value: '15', label: 'Setúbal' },
    { value: '16', label: 'Viana do Castelo' },
    { value: '17', label: 'Vila Real' },
    { value: '18', label: 'Viseu' },
    { value: '20', label: 'Região Autónoma dos Açores' },
    { value: '30', label: 'Região Autónoma da Madeira' },
  ],

  SE: [
    { value: 'K', label: 'Blekinge län' },
    { value: 'W', label: 'Dalarnas län' },
    { value: 'I', label: 'Gotlands län' },
    { value: 'X', label: 'Gävleborgs län' },
    { value: 'N', label: 'Hallands län' },
    { value: 'Z', label: 'Jämtlands län' },
    { value: 'F', label: 'Jönköpings län' },
    { value: 'H', label: 'Kalmar län' },
    { value: 'G', label: 'Kronobergs län' },
    { value: 'BD', label: 'Norrbottens län' },
    { value: 'M', label: 'Skåne län' },
    { value: 'AB', label: 'Stockholms län' },
    { value: 'D', label: 'Södermanlands län' },
    { value: 'C', label: 'Uppsala län' },
    { value: 'S', label: 'Värmlands län' },
    { value: 'AC', label: 'Västerbottens län' },
    { value: 'Y', label: 'Västernorrlands län' },
    { value: 'U', label: 'Västmanlands län' },
    { value: 'O', label: 'Västra Götalands län' },
    { value: 'T', label: 'Örebro län' },
    { value: 'E', label: 'Östergötlands län' },
  ],

  TR: [
    { value: '01', label: 'Adana' },
    { value: '02', label: 'Adıyaman' },
    { value: '03', label: 'Afyonkarahisar' },
    { value: '04', label: 'Ağrı' },
    { value: '68', label: 'Aksaray' },
    { value: '05', label: 'Amasya' },
    { value: '06', label: 'Ankara' },
    { value: '07', label: 'Antalya' },
    { value: '75', label: 'Ardahan' },
    { value: '08', label: 'Artvin' },
    { value: '09', label: 'Aydın' },
    { value: '10', label: 'Balıkesir' },
    { value: '74', label: 'Bartın' },
    { value: '72', label: 'Batman' },
    { value: '69', label: 'Bayburt' },
    { value: '11', label: 'Bilecik' },
    { value: '12', label: 'Bingöl' },
    { value: '13', label: 'Bitlis' },
    { value: '14', label: 'Bolu' },
    { value: '15', label: 'Burdur' },
    { value: '16', label: 'Bursa' },
    { value: '17', label: 'Çanakkale' },
    { value: '18', label: 'Çankırı' },
    { value: '19', label: 'Çorum' },
    { value: '20', label: 'Denizli' },
    { value: '21', label: 'Diyarbakır' },
    { value: '81', label: 'Düzce' },
    { value: '22', label: 'Edirne' },
    { value: '23', label: 'Elazığ' },
    { value: '24', label: 'Erzincan' },
    { value: '25', label: 'Erzurum' },
    { value: '26', label: 'Eskişehir' },
    { value: '27', label: 'Gaziantep' },
    { value: '28', label: 'Giresun' },
    { value: '29', label: 'Gümüşhane' },
    { value: '30', label: 'Hakkâri' },
    { value: '31', label: 'Hatay' },
    { value: '76', label: 'Iğdır' },
    { value: '32', label: 'Isparta' },
    { value: '34', label: 'İstanbul' },
    { value: '35', label: 'İzmir' },
    { value: '46', label: 'Kahramanmaraş' },
    { value: '78', label: 'Karabük' },
    { value: '70', label: 'Karaman' },
    { value: '36', label: 'Kars' },
    { value: '37', label: 'Kastamonu' },
    { value: '38', label: 'Kayseri' },
    { value: '71', label: 'Kırıkkale' },
    { value: '39', label: 'Kırklareli' },
    { value: '40', label: 'Kırşehir' },
    { value: '79', label: 'Kilis' },
    { value: '41', label: 'Kocaeli' },
    { value: '42', label: 'Konya' },
    { value: '43', label: 'Kütahya' },
    { value: '44', label: 'Malatya' },
    { value: '45', label: 'Manisa' },
    { value: '47', label: 'Mardin' },
    { value: '33', label: 'Mersin' },
    { value: '48', label: 'Muğla' },
    { value: '49', label: 'Muş' },
    { value: '50', label: 'Nevşehir' },
    { value: '51', label: 'Niğde' },
    { value: '52', label: 'Ordu' },
    { value: '80', label: 'Osmaniye' },
    { value: '53', label: 'Rize' },
    { value: '54', label: 'Sakarya' },
    { value: '55', label: 'Samsun' },
    { value: '56', label: 'Siirt' },
    { value: '57', label: 'Sinop' },
    { value: '58', label: 'Sivas' },
    { value: '63', label: 'Şanlıurfa' },
    { value: '73', label: 'Şırnak' },
    { value: '59', label: 'Tekirdağ' },
    { value: '60', label: 'Tokat' },
    { value: '61', label: 'Trabzon' },
    { value: '62', label: 'Tunceli' },
    { value: '64', label: 'Uşak' },
    { value: '65', label: 'Van' },
    { value: '77', label: 'Yalova' },
    { value: '66', label: 'Yozgat' },
    { value: '67', label: 'Zonguldak' },
  ],
};
